export const WEBAPP_URL="https://interview-app.mitras.ai"
export const CONTACT_US_URL=""